export default class PrintParam5 {
  constructor(label, data) {
    this.label = label
    this.data = data
  }
}

export const EMPTY_PRINT_PARAM5 = new PrintParam5('', '')
export const SEABRIDGE_FCL_PRINT_PARAM5 = new PrintParam5('SEABRIDGE FCL', 'DELIVERY ORDER FEE ON ACCOUNT OF CNEE')
export const SEABRIDGE_LCL_NORMAL_PRINT_PARAM5 = new PrintParam5('SEABRIDGE LCL NORMAL', 'DESTINATION CFS CHARGES INCL.DELIVERY ORDER FEE AND GSC CHARGES ON ACCOUNT OF CNEE')
export const SEABRIDGE_LCL_INCLUDE_CISF_PRINT_PARAM5 = new PrintParam5('SEABRIDGE LCL INCLUDE CISF', 'DESTINATION CFS CHARGES INCL.DELIVERY ORDER FEE AND GSC CHARGES AND CISF ON ACCOUNT OF CNEE')

export const PRINT_PARAM5_TYPES = [
  EMPTY_PRINT_PARAM5,
  SEABRIDGE_FCL_PRINT_PARAM5,
  SEABRIDGE_LCL_NORMAL_PRINT_PARAM5,
  SEABRIDGE_LCL_INCLUDE_CISF_PRINT_PARAM5
]
